export { default as Ambulance } from "./Ambulance";
export { default as EmergencyUrgency } from "./EmergencyUrgency";
export { default as HomeCare } from "./HomeCare";
export { default as HomeConsultations } from "./HomeConsultations";
export { default as PediatricDivision } from "./PediatricDivision";
export { default as PersonalPhysician } from "./PersonalPhysician";
export { default as ProtectedCarHouse } from "./ProtectedCarHouse";
export { default as SanitaryTransfers } from "./SanitaryTransfers";
export { default as ScheduledTransfers } from "./ScheduledTransfers";
export { default as SMGBacking } from "./SMGBacking";
export { default as TrainingCourses } from "./TrainingCourses";
export { default as TravelerCoverage } from "./TravelerCoverage";
export { default as IcMail } from "./IcMail";
export { default as Group } from "./Group";
export { default as Enterprise } from "./Enterprise";
export { default as Doctor } from "./Doctor";
export { default as Truck } from "./Truck";
export { default as AmbulancePhone } from "./AmbulancePhone";
export { default as StarOfLife } from "./StarOfLife";
export { default as PhoneAtencion } from "./PhoneAtencion";
export { default as IconAfiliaciones } from "./IconAfiliaciones";
export { default as IconLayoutGrid } from "./IconLayoutGrid";
export { default as Coverage } from "./Coverage";
export { default as CalendarLight } from "./CalendarLight";
export { default as EFactura } from "./EFactura";
export { default as MyAccount } from "./MyAccount";
export { default as Download } from "./Download";
export { default as MyProfile } from './MyProfile';
export { default as ThumbUpOutlinedIcon } from "./ThumbUpOutlinedIcon";
export { default as ThumbDownOutlinedIcon } from "./ThumbDownOutlinedIcon";
export { default as HourglassEmptyOutlinedIcon } from "./HourglassEmptyOutlinedIcon";
export { default as Area } from "./Area";
export { default as CoberturaEventos} from "./CoberturaEventos";
export { default as EConsulta} from "./EConsulta";
export { default as OrientacionMedicaTelefonica } from "./OrientacionMedicaTelefonica";
export { default as CheckSuccess} from "./CheckSuccess"
export { default as Facebook} from "./Facebook"
export { default as Instagram} from "./Instagram"
export { default as LinkedIn} from "./LinkedIn"
export { default as Contributor} from "./Contributor"
export { default as Pgm} from "./Pgm"